import React from 'react';
import { Modal, Form, Input, Select, Row, Col, Button, Space, FormInstance } from 'antd';
import { SourceChapter } from '../../../types';

const { Option } = Select;

interface CreateProcessModalProps {
  visible: boolean;
  onCancel: () => void;
  onSubmit: (values: any) => void;
  chapters: SourceChapter[];
  form: FormInstance;
  loading: boolean;
}

const CreateProcessModal: React.FC<CreateProcessModalProps> = ({
  visible,
  onCancel,
  onSubmit,
  chapters,
  form,
  loading,
}) => {
  return (
    <Modal
      title="Create New Process"
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={600}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onSubmit}
      >
        <Form.Item
          name="name"
          label="Process Name"
        >
          <Input placeholder="Leave blank for auto-generation (e.g. Chapters 1-5 analysis)" />
        </Form.Item>

        <Form.Item
          name="videoForm"
          label="Video Form"
          rules={[{ required: true, message: 'Please select video form' }]}
        >
          <Select placeholder="Select video form">
            <Option value="LONG">Long (16:9)</Option>
            <Option value="SHORT">Short (9:16)</Option>
          </Select>
        </Form.Item>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="startChapterId"
              label="From Chapter"
              rules={[{ required: true, message: 'Please select start chapter' }]}
            >
              <Select placeholder="Select start" showSearch optionFilterProp="children">
                {chapters.map((chapter, index) => {
                  return (
                    <Option key={chapter.id} value={chapter.id}>
                      {chapter.name || `Chapter ${index + 1}`}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="endChapterId"
              label="To Chapter"
              rules={[{ required: true, message: 'Please select end chapter' }]}
            >
              <Select placeholder="Select end" showSearch optionFilterProp="children">
                {chapters.map((chapter, index) => {
                  return (
                    <Option key={chapter.id} value={chapter.id}>
                      {chapter.name || `Chapter ${index + 1}`}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
          <Space>
            <Button onClick={onCancel}>
              Cancel
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
            >
              Create
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateProcessModal;
